"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIGGERS = exports.TEXT_PROPS = exports.CONTENT_POSITION = void 0;
var TRIGGERS = {
  hover: 'hover',
  click: 'click',
  focus: 'focus'
};
exports.TRIGGERS = TRIGGERS;
var TEXT_PROPS = {
  display: 'inlineFlex',
  type: 'default'
};
exports.TEXT_PROPS = TEXT_PROPS;
var CONTENT_POSITION = {
  RIGHT: 'RIGHT',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM'
};
exports.CONTENT_POSITION = CONTENT_POSITION;